'use strict';

var style = require('./style');

module.exports = style({
  prop: 'fontWeight',
  key: 'fontWeights'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/font-weight.js
// module id = 661
// module chunks = 3